import { all, call, put, takeLatest } from 'redux-saga/effects'
import ErrorLogger from 'builder/services/ErrorLogger'
import { apiClient, baseAppClient } from 'builder/modules/apiClient'
import { actions } from './billingModule'
import {
  AvailablePlansResponse,
  YearlyOfferPlanResponse,
  PaymentMethodsResponse,
  AdyenConfigResponse,
  ScenarioResponse,
} from './types'

export function* fetchYearlyOfferPlanSaga() {
  try {
    const { data } = (yield call(apiClient.get, `/payment-plans/yearly-offer`)) as {
      data: YearlyOfferPlanResponse
    }
    yield put(actions.setYearlyOfferPlan(data.data))
  } catch (error) {
    ErrorLogger.log(error)
  }
}

export function* fetchAvailablePlansSaga() {
  try {
    yield put(actions.setPlansLoading(true))
    const { data } = (yield call(apiClient.get, '/billing/plans')) as {
      data: AvailablePlansResponse
    }
    yield put(actions.setAvailablePlans(data.plans))
  } catch (error) {
    yield put(
      actions.setPlansError(error instanceof Error ? error.message : 'Failed to load plans'),
    )
    ErrorLogger.log(error)
  } finally {
    yield put(actions.setPlansLoading(false))
  }
}

export function* fetchScenarioSaga() {
  try {
    const { data } = (yield call(apiClient.get, '/billing/scenario')) as {
      data: ScenarioResponse
    }
    yield put(actions.setScenarioName(data.scenarioName))
  } catch (error) {
    ErrorLogger.log(error)
  }
}

export function* fetchPaymentMethodsSaga(action: { payload: { plan: string } }) {
  try {
    yield put(actions.setPaymentMethodsLoading(true))
    const { data } = (yield call(baseAppClient.get, `/billing/charge_bee/payment_methods`, {
      params: { plan: action.payload.plan },
    })) as { data: PaymentMethodsResponse }
    yield put(actions.setPaymentMethods(data))
  } catch (error) {
    ErrorLogger.log(error)
  } finally {
    yield put(actions.setPaymentMethodsLoading(false))
  }
}

export function* fetchAdyenConfigSaga() {
  try {
    yield put(actions.setAdyenConfigLoading(true))
    const { data } = (yield call(baseAppClient.get, '/billing/charge_bee/adyen_config')) as {
      data: AdyenConfigResponse
    }
    yield put(actions.setAdyenConfig(data))
  } catch (error) {
    ErrorLogger.log(error)
  } finally {
    yield put(actions.setAdyenConfigLoading(false))
  }
}

/** Bind side-effect handlers */
export const sagas = function* saga() {
  yield all([
    takeLatest(actions.fetchYearlyOfferPlan, fetchYearlyOfferPlanSaga),
    takeLatest(actions.fetchAvailablePlans, fetchAvailablePlansSaga),
    takeLatest(actions.fetchScenario, fetchScenarioSaga),
    takeLatest(actions.fetchPaymentMethods, fetchPaymentMethodsSaga),
    takeLatest(actions.fetchAdyenConfig, fetchAdyenConfigSaga),
  ])
}
